<template>
  <div>
    <Card>
      <ui-tooltip-icon
        preset="help"
        text="Help tooltip"
      ></ui-tooltip-icon>
    </Card>
    <Card>
      <ui-tooltip-icon
        preset="warning"
        text="Warning tooltip"
      ></ui-tooltip-icon>
    </Card>
    <Card>
      <ui-tooltip-icon
        preset="error"
        text="Error tooltip"
      ></ui-tooltip-icon>
    </Card>
    <Card>
      <ui-tooltip-icon
        icon="fas fa-plus"
        :color="$colors.violet"
        text="Custom tooltip"
      ></ui-tooltip-icon>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { useColors } from '@/composables';

const $colors = useColors();
</script>
